import * as iconoir from "@attaditya/iconoir-preact/regular";
import { Container } from "@components/ui/structure/container";
import { Heading } from "@components/ui/text/heading";
import { useClasses } from "@styles";

interface PageHeaderProps {
  title: string;
  icon: keyof typeof iconoir
}

export function PageHeader({ title, icon }: PageHeaderProps) {
  const Icon = iconoir[icon];

  return (<>
    <Container className={useClasses("profile-view-header")}>
      <Container className={useClasses("profile-view-header-icon")}>
        <Icon />
      </Container>

      <Heading size="max">
        {title}
      </Heading>
    </Container>
  </>);
}

